export enum SharedFeatureFlags {
  Add2HomeScreen = 'a2hs',
  AllowSoftRedirectCancel = 'allow-soft-redirect-cancel',
  BankID = 'se-bankid-signup',
  Chest = 'chestPageEnabled',
  DisableBuenosAiresFeatures = 'DisableBuenosAiresFeatures',
  DisableNewUkAgeVerificationFlow = 'DisableNewUkAgeVerificationFlow',
  DisableRam = 'DisableRam',
  DivertRAMToPoker = 'DivertRAMToPoker',
  EnableBigWinningsGQLSubscription = 'EnableBigWinningsGQLSubscription',
  ForceDefaultLocale = 'ForceDefaultLocale',
  Freemium = 'eFreemium',
  IDScanSDK = 'IDScan-SDK',
  LiveChatSupport = 'eLiveChatSupport',
  LoginSEDialogue = 'loginSEDialogue',
  LoginSummaryNotificationModification = 'login-summary-notification-modification',
  NPS = 'SW-SimpleNPS',
  NPSPhase2 = 'SW-NPSPhase2',
  PlayMoney = 'playMoney',
  PmcPaywall = 'pmc-paywall',
  SeparatedEulaPrivacyPolicy = 'separated_eula_privacy_policy',
  SessionPopupExtended = 'sessionPopupExtended',
  SportsNonAuth = 'sports-non-auth',
  StrongAuthQuestionsPwdRecovery = 'strong-auth-questions-pwd-recovery',
  StrongAuthQuestionsPwdReset = 'strong-auth-questions-pwd-reset',
  UseRam1 = 'UseRam1',
  VegasPanicButtonDialogNewText = 'de-vegas-panic-button-dialog-new-text',
  VerifyAccount = 'verify-account',
  VerifyAccountAfterRmf = 'verify-account-after-rmf',
  VerifyAccountDrivingLicense = 'verify-account-driving-license',
  VerifyAccountNationalId = 'verify-account-national-id',
  VerifyAccountPassport = 'verify-account-passport',
  VerifyDoc = 'verify-doc',
  VerifyDocSecondary = 'verify-doc-secondary',
  VerifyWCSF = 'verify-wcsf'
}
